define('commons/device-coverage-map',['jquery', 'commons/coverage-map', 'utils/icons', 'async!google-maps'], function($, CoverageMap, icons) {

    /**
     * <pre>
     * markerInfo = {
     *      CoverageMap.marketInfo,
     *      name: device's name,
     *      hexId: device's id in hexadecimal,
     *      comState: the device communication status,
     *      lastCom: the device last communication date
     *      
     * }
     * </pre>
     */
    var DeviceCoverageMap = function(mapNodeId, options) {

        var opts = {
            clusterer : {
                isDisabled : true,
            },
            rectangleOptions: {
                fillColor: "#00CCFF",
                fillOpacity: 0.3,
                strokeColor: "#009999",
                strokeOpacity: 0.5,
                strokeWeight: 1
            }
        };
        $.extend(opts, options);

        // Call the inherited coverage map constructor
        CoverageMap.call(this, mapNodeId, opts);

        this.rectangles = [];
        this.circles = [];
    };

    // Inherit from CoverageMap
    for ( var element in CoverageMap.prototype) {
        DeviceCoverageMap.prototype[element] = CoverageMap.prototype[element];
    }

    /**
     * @OVERRIDE
     */
    DeviceCoverageMap.prototype._getIcon = function(markerInfo) {
        return icons.device["STATUS_" + markerInfo.comStateString.toUpperCase()];
    };

    /**
     * @OVERRIDE
     */
    DeviceCoverageMap.prototype._getInfoContent = function(markerInfo) {
        return '<a href="/device/' + markerInfo.id + '">Device id: ' + markerInfo.hexId + '</a></p><p>Name: ' + markerInfo.name + '</p>' +
                '<p>Message time: ' + markerInfo.lastCom + '</p><p>Lat: ' + markerInfo.lat + '</p><p>Lng: ' + markerInfo.lng + '</p>' +
                (markerInfo.radius ? '<p>Radius: ' + markerInfo.radius + '</p>' : "");
    };

    DeviceCoverageMap.prototype.rectangle = function(coverage, display) {
        var sw = new google.maps.LatLng(coverage.bounds.sw.lat, coverage.bounds.sw.lng);
        var ne = new google.maps.LatLng(coverage.bounds.ne.lat, coverage.bounds.ne.lng);
        var bounds = new google.maps.LatLngBounds(sw, ne);

        if (display) {
            // Draw a rectangle representing the coverage area
            var rectangle = new google.maps.Rectangle({
                fillColor: this.settings.rectangleOptions.fillColor,
                fillOpacity: this.settings.rectangleOptions.fillOpacity,
                strokeColor: this.settings.rectangleOptions.strokeColor,
                strokeOpacity: this.settings.rectangleOptions.strokeOpacity,
                strokeWeight: this.settings.rectangleOptions.strokeWeight,
                map: this.map,
                bounds: bounds
            });
            this.rectangles.push(rectangle);
        }
        this._unionBounds(bounds);
        this.fitBounds();
    };

    DeviceCoverageMap.prototype.estimatedPosition = function(device) {
        var circleCenter = new google.maps.LatLng(device.circleLat, device.circleLng);

        var circle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.35,
            strokeWeight: 1,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: this.map,
            center: circleCenter,
            radius: device.circleRadius,
            zInfdex: 1000
        });

        this.circles.push(circle);

        this.addMarker({
            id: device.id,
            hexId: device.hexId,
            lastCom: device.lastCom,
            lat: device.circleLat,
            lng: device.circleLng,
            radius: device.circleRadius,
            draggable: false,
            removable: true,
            title: "Estimated position of " + device.hexId,
            name: "Estimated position of " + device.name,
            comStateString: device.comStateString
        }, true);

        this._unionBounds(circle.getBounds());
        this.fitBounds();
    };

    DeviceCoverageMap.prototype._unionBounds = function(bounds) {
        if (this.bounds === null) {
            this.bounds = bounds;
        } else {
            this.bounds.union(bounds);
        }
        this.boundsCount++;
    };

    /**
     * <pre>
     * Removeallcoverages
     * </pre>
     */
    DeviceCoverageMap.prototype.removeCoverages = function(useTile) {
        if (useTile) {
            this.removeTiles();
        } else {
            // Call the parent function
            CoverageMap.prototype.removeCoverages.call(this);
        }
        for (var i = 0; i < this.rectangles.length; i++) {
            this.rectangles[i].setMap(null);
        }
        this.rectangles.length = 0;
        for (var j = 0; j < this.circles.length; j++) {
            this.circles[j].setMap(null);
        }
        this.circles.length = 0;
        this.bounds = null;
    };

    return DeviceCoverageMap;
});
